
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/method",
      function () {
        return require("private-next-pages/method.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/method"])
      });
    }
  